/* Whether a redirect target is a path on this app — STORY-009.
 *
 * Shared because two places must agree about it and disagreeing is a security
 * bug: the router validates the `redirect` search parameter with it, and the
 * test route tree mirrors that validation. A second copy would let the tests
 * prove a rule the product does not enforce.
 *
 * The rule: a sign-in screen that will send somebody to an arbitrary URL after
 * they authenticate is an open redirect, and it is the single most useful page
 * in a product to phish through — the victim really did sign in to the real
 * site before being sent somewhere else.
 */

/**
 * True only for a path on this origin.
 *
 * `//evil.example` and `/\evil.example` are the two that get missed. Both are
 * read by browsers as protocol-relative URLs pointing somewhere else entirely,
 * and both start with `/`, so a `startsWith('/')` check alone lets them past.
 */
export const isInAppPath = (value: string): boolean =>
  value.startsWith('/') && value[1] !== '/' && value[1] !== '\\';
